import React, { useState } from "react";
import { env } from "../config";

function CloudStackFaq(props: any) {
    const { title, description, Features } = props;
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    return (
        <div className="bg-[#FEF2E4] font-custom relative overflow-hidden">
            <svg
                className=" hidden lg:block scale-75 lg:absolute top-[5%] rotate-12 left-[50%] opacity-0 lg:opacity-100"
                width="380"
                height="375"
                viewBox="0 0 380 375"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M333.804 3.78118C360.805 -2.45681 384.434 22.8746 376.335 49.3776L285.354 347.121C277.255 373.624 243.503 381.422 224.6 361.157L12.2375 133.492C-6.66555 113.227 3.45763 80.0985 30.4593 73.8605L333.804 3.78118Z"
                    stroke="#5F5F5F"
                    strokeOpacity="0.2"
                    strokeWidth="4"
                />
            </svg>

            <svg
                className="z-10 hidden lg:block scale-75 lg:absolute -bottom-20 right-[5%] opacity-0 lg:opacity-100"
                width="380"
                height="375"
                viewBox="0 0 380 375"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M333.804 3.78118C360.805 -2.45681 384.434 22.8746 376.335 49.3776L285.354 347.121C277.255 373.624 243.503 381.422 224.6 361.157L12.2375 133.492C-6.66555 113.227 3.45763 80.0985 30.4593 73.8605L333.804 3.78118Z"
                    stroke="#5F5F5F"
                    strokeOpacity="0.2"
                    strokeWidth="4"
                />
            </svg>
            <div
                className={`text-black-75   px-5 py-7 lg:px-10 xl:px-20 lg:py-14 mx-auto max-w-6xl `}
            >
                <div
                    className={`text-2xl md:text-4xl lg:text-5xl flex justify-center mb-3 mx-auto  leading-loose text-center font-custom font-bold`}
                >
                    {title}
                </div>
                <div className="lg:text-lg md:text-base  font-normal  pt-2  text-center mb-7 max-w-[50ch] mx-auto">
                    {description}
                </div>



                <div className="w-full space-y-3">
                    {Features?.map((node: any, index: number) => {
                        const isOpen = openIndex === index;

                        return (
                            <div
                                key={index + node?.Title}
                                data-aos="fade-left"
                                data-aos-delay={`${index === 0 ? 150 : index * 150}`}
                                className="bg-white border border-[#dddddd] rounded-[6px] overflow-hidden"
                            >
                                <button
                                    type="button"
                                    onClick={() => setOpenIndex(isOpen ? null : index)}
                                    className="w-full flex items-center justify-between px-5 py-4 text-left"
                                >
                                    <span className="font-custom font-bold text-base text-[#3f3f3f]">
                                        {node?.Title}
                                    </span>

                                    <span className="text-2xl leading-none text-[#444]">
                                        {isOpen ? "−" : "+"}
                                    </span>
                                </button>

                                {isOpen && (
                                    <div className="px-5 pb-4 font-custom text-base text-[#4a4a4a]">
                                        {node?.Description}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default CloudStackFaq;
